import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classnames from 'classnames';
import React, { useContext } from 'react';
import { Loading, Toast, NoticeBar, Modal as ZaModal } from 'zarm';
import { fetchClick } from '@/components/Button';
import { dispatch, getState, getFormValue } from '@/store';
import { getHashParam } from '@/utils/tool';
import { getFetchBaseData, findModuleFromCurrPage } from '@/utils/utils';
import { ModuleContext } from '../BaseModule';
import { getLocalClick } from '../Button';
import './index.less';
const SimpleButton = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    attrs,
    events,
    form
  } = props;
  const {
    buttonText = '',
    buttonId
  } = attrs;
  const context = useContext(ModuleContext) || {};
  const {
    buttonCode,
    component: moduleComponent
  } = context;
  const cls = classnames({
    'components-simple-button-render': true
  });
  const btnCls = classnames({
    btn: true
  }); // 获取下一步请求参数

  const getFetchDataWithNotice = () => {
    var _getState;

    const data = getFetchBaseData();
    data.buttonCode = buttonCode; // data.premium = '';
    // 如何不在下面这几个模块使用sinmpleButton 将不需要整合告知信息作为入参数

    const includeArr = ['healthInfoModule', 'policyHolderInfoModule'];

    if (!includeArr.includes(moduleComponent)) {
      return data;
    }

    const noticeType = moduleComponent === 'policyHolderInfoModule' ? 'holder' : 'insured';
    const notice = (_getState = getState('notice')) === null || _getState === void 0 ? void 0 : _getState[noticeType];
    const {
      certNo
    } = getHashParam() || {};
    let currentInsured = 0;

    if (certNo) {
      // 找出是第几个被保人
      const insured = getFormValue('insured');
      currentInsured = insured.findIndex(i => i.certNo === certNo);
      data.extraInfo.currentInsuredFlag = certNo;
    }

    if (!notice) {
      return data;
    }

    const {
      noticeDetailList = []
    } = notice;
    const nextNoticeDetailList = noticeDetailList.map((item = {}, index) => {
      // const noticeAnswer = buttonId;
      const noticeAnswer = buttonText.includes('是') ? 'unknown' : 'no';
      return _objectSpread(_objectSpread({}, item), {}, {
        noticeAnswer
      });
    });

    const noticeQuestion = _objectSpread(_objectSpread({}, notice), {}, {
      noticeDetailList: nextNoticeDetailList
    }); // const { state } = JSON.parse(sessionStorage.getItem('STATE'));
    // const { currentInsured = 0 } = state?.otherParams || {};


    const {
      holderNotice,
      insuredNotice
    } = getState('healthNoticeInformation') || []; // 投保人告知处理

    if (moduleComponent === 'policyHolderInfoModule') {
      var _ref;

      noticeQuestion.smartQuestionContent = (_ref = holderNotice || {}) === null || _ref === void 0 ? void 0 : _ref.smartQuestionContent;
      data.holder = _objectSpread(_objectSpread({}, data.holder), {}, {
        noticeQuestion
      });
      dispatch({
        'healthNoticeInformation.holderNotice': noticeQuestion
      });
    } else if (moduleComponent === 'healthInfoModule') {
      // 被保人告知处理
      data.insuredList = data.insuredList || [];
      data.insuredList = data.insuredList.map((item = {}, index) => {
        var _index, _data$insuredList;

        noticeQuestion.smartQuestionContent = (_index = (insuredNotice || [])[index]) === null || _index === void 0 ? void 0 : _index.smartQuestionContent;
        dispatch({
          [`healthNoticeInformation.insuredNotice[${currentInsured}]`]: noticeQuestion
        }); // data?.insuredList?.length === 1说明是单被保人

        if (index === currentInsured || (data === null || data === void 0 ? void 0 : (_data$insuredList = data.insuredList) === null || _data$insuredList === void 0 ? void 0 : _data$insuredList.length) === 1) {
          return _objectSpread(_objectSpread({}, item), {}, {
            noticeQuestion: _objectSpread({}, noticeQuestion)
          });
        }

        return _objectSpread({}, item);
      });
    }

    return data;
  }; // 调用下一步请求


  const getNextStep = async _buttonCode => {
    await form.validateFields();
    Loading.show();
    const data = getFetchDataWithNotice();

    if (_buttonCode) {
      data.buttonCode = _buttonCode;
    } // data.noticeObjectType = noticeObjectType;


    Loading.hide();
    fetchClick(data, (resData = {}, next) => {
      const {
        pageAction
      } = resData;

      if (pageAction === 'continue') {
        // eslint-disable-next-line no-use-before-define
        return onClickLocal;
      }

      return next;
    });
  }; // 按钮配置事件处理


  const onClickLocal = getLocalClick(events, (opt, next) => {
    const {
      type = '',
      behavior = ''
    } = opt;

    if (type === 'behavior' && behavior === 'continue') {
      return () => {
        getNextStep();
      };
    }

    return next;
  });
  const {
    channelCodeStatus
  } = getState('otherParams') || {};

  const handleClick = async () => {
    // 对逐页阅读弹逻辑处理
    // 在逐页阅读弹出层会dispatch一个全局状态标识阅读按钮是否被点击，此处需要读取这个状态
    const hasSupervisionPopupModule = findModuleFromCurrPage('supervisionPopupModule');

    if (hasSupervisionPopupModule) {
      const supervisionClicked = getState('supervisionBtnClicked');
      const {
        clicked = false,
        supervisionTarget
      } = supervisionClicked;

      if (!clicked) {
        if (supervisionTarget) {
          // supervision 监督
          const target = getState(supervisionTarget); // 带有逐页阅读模块的页面后退进入其他页面时残余数据会走下面的方法 阻止调用下一步方法

          if (target) {
            target.setTab(1);
            const result = await target.show();
            if (!result) return Toast.show('请仔细阅读并勾选投保须知');
          }
        }
      }
    }

    if (events && events.type) {
      onClickLocal();
    } else {
      getNextStep();
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, channelCodeStatus === 'offSale' ? /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: cls
  }, /*#__PURE__*/React.createElement("div", {
    className: btnCls,
    style: {
      backgroundColor: '#ccc'
    }
  }, "\u6682\u505C\u6295\u4FDD")) : /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: cls
  }, /*#__PURE__*/React.createElement("div", {
    className: btnCls,
    onClick: handleClick
  }, buttonText)));
});
export default SimpleButton;